/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer/Footer.jsx";
// dinamically create pages routes
import {mauiRoutes} from "../routes";
import bgImage from "../assets/img/full-screen-image-2.jpg";

let routes = mauiRoutes.getRoutes();

class Pages extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }

  getPageClass() {
    var pageClass = "";
    switch (this.props.location.pathname.toLowerCase()) {
      case "/auth/login":
        pageClass = "full-page login-page";
        break;
      case "/auth/forgotpassword":
        pageClass = "full-page login-page";
        break;
      case "/auth/resetpassword":
        pageClass = "full-page login-page";
        break;
      case "/auth/twofactorauthentication":
        pageClass = "full-page login-page";
        break;
      case "/auth/changepassword":
        pageClass = "full-page login-page";
        break;
      case "/auth/register-page":
        pageClass = "full-page register-page";
        break;
      case "/auth/lock-screen-page":
        pageClass = "full-page lock-page";
        break;
      default:
        pageClass = "full-page";
        break;
    }
    return pageClass;
  }

  getContentClass() {
    let contentClass = "";
    switch (this.props.location.pathname.toLowerCase()) {
      case "/auth/login":
        contentClass = "content";
        break;
      default:
        contentClass = "content";
        break;
    }
    return contentClass;
  }

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => (
              <prop.component {...props}/>
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <div>
        <div className="wrapper wrapper-full-page knoaAuth">
          <div
            className={this.getPageClass()}
            data-color="blue"
            data-image={bgImage}
          >
            <div className={this.getContentClass()}>
              <Switch>{this.getRoutes(routes)}</Switch>
            </div>
            {this.props.location.pathname!=='/auth/customerSupport' &&
            <Footer transparent loginpage/>
            }
            <div
              className="full-page-background"
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;